<template>
  <div>
    <tree-view :tree="treeData" v-on:operate="operate"></tree-view>
  </div>
</template>

<script>
  import TreeView from '@/components/utils/tree-view'
  import { GlobalManager } from '@/components/home/controllers/global'

  export default {
    data () {
      return {
        treeData: [
          {
            id: 'root-node1',
            name: '上报连接设置',
            operations: [ 'edit', 'click' ]
          }
        ]
      }
    },
    components: {
      TreeView
    },
    created () {
      this._globalManager = new GlobalManager(this)
    },
    methods: {
      operate (operation, data) {
        switch (operation) {
          case 'edit':
            this._globalManager.editUploadConfig()
            break
          case 'click':
            this._globalManager.inspectUploadConfig()
            break
          default:
            break
        }
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/trees/connection-tree.vue